/* Express Matting header: core behaviour (menus, drawer, layers, popovers, status, VAT).
   Works on server-rendered markup; no dependencies. Commerce features live in em-header-commerce.js. */
(() => {
  const root = document.querySelector("[data-emh]");
  if (!root || root.dataset.emhReady) return;
  root.dataset.emhReady = "1";
  root.classList.add("emh-js");

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const ic = (n, cls = "emh-ic") => `<svg class="${cls}" aria-hidden="true"><use href="#emh-i-${n}"/></svg>`;
  const store = {
    get(k, d) { try { const v = localStorage.getItem("emh:" + k); return v ? JSON.parse(v) : d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem("emh:" + k, JSON.stringify(v)); } catch { } }
  };
  const isSmall = () => matchMedia("(max-width: 960px)").matches;
  const coarse = () => matchMedia("(hover: none)").matches;
  const D = root.dataset;

  /* ---------- VAT ---------- */
  const incVatPrices = D.vatInc !== "false";
  let vatMode = store.get("vat", "inc");
  const shown = gross => vatMode === "ex" && incVatPrices ? gross / 1.2 : gross;
  const money = n => "£" + Number(n).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const vatLabel = () => vatMode === "ex" ? "ex VAT" : "inc VAT";
  function paintPrices(scope = document) {
    $$("[data-emh-price]", scope).forEach(el => { el.textContent = money(shown(+el.dataset.emhPrice)); });
    $$("[data-emh-vat-l]", scope).forEach(el => { el.textContent = vatLabel(); });
    $$("[data-emh-vat]").forEach(b => b.setAttribute("aria-pressed", b.dataset.emhVat === vatMode));
  }
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-emh-vat]"); if (!b) return;
    vatMode = b.dataset.emhVat; store.set("vat", vatMode); paintPrices();
    document.dispatchEvent(new CustomEvent("emh:vat"));
    toast(vatMode === "ex" ? "Showing prices without VAT" : "Showing prices with VAT");
  });

  /* ---------- Toast ---------- */
  const toastEl = $("[data-emh-toast]"); let tt;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.innerHTML = ic("check") + `<span>${esc(msg)}</span>`;
    toastEl.classList.add("is-show"); clearTimeout(tt);
    tt = setTimeout(() => toastEl.classList.remove("is-show"), 2800);
  }

  /* ---------- Analytics: every header click is reported ---------- */
  root.addEventListener("click", e => {
    const a = e.target.closest("a[href]"); if (!a) return;
    const detail = { label: (a.dataset.emhLabel || a.textContent || "").trim().replace(/\s+/g, " ").slice(0, 80), href: a.getAttribute("href"), zone: a.closest("[data-emh-mega]") ? "mega" : a.closest(".emh-nav") ? "rail" : "header" };
    try { (window.dataLayer = window.dataLayer || []).push({ event: "emh_nav_click", ...detail }); } catch { }
    try { window.Shopify?.analytics?.publish?.("emh_nav_click", detail); } catch { }
  }, true);

  /* ---------- Scheduled menu items ---------- */
  const now = Date.now();
  $$("[data-show-from], [data-show-until]", root).forEach(li => {
    const f = Date.parse(li.dataset.showFrom || ""), u = Date.parse(li.dataset.showUntil || "");
    if ((f && now < f) || (u && now > u)) li.hidden = true;
  });

  /* ---------- Mega menus with hover intent ---------- */
  const dim = $("[data-emh-dim]");
  const items = $$(".emh-item", root).filter(li => $("[data-emh-mega]", li));
  let openLi = null, tOpen = 0, tClose = 0;
  function openMega(li, { focus = false } = {}) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (isSmall()) { const id = li.dataset.emhItem; window.EMH.openDrawer(id); return; }
    const swap = !!openLi;
    if (openLi && openLi !== li) closeMega(false, true);
    const panel = $("[data-emh-mega]", li);
    panel.classList.toggle("is-swap", swap);
    panel.classList.add("is-open"); li.classList.add("is-open");
    $(".emh-toggle", li)?.setAttribute("aria-expanded", "true");
    openLi = li; root.classList.add("emh-mega-open"); if (dim) dim.hidden = false;
    paintPrices(panel);
    if (focus) panel.querySelector("a, button, input, select")?.focus();
    document.dispatchEvent(new CustomEvent("emh:mega", { detail: panel }));
  }
  function closeMega(returnFocus, swapping) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!openLi) return;
    const li = openLi;
    $("[data-emh-mega]", li).classList.remove("is-open"); li.classList.remove("is-open");
    $(".emh-toggle", li)?.setAttribute("aria-expanded", "false");
    openLi = null;
    if (!swapping) { root.classList.remove("emh-mega-open"); if (dim) dim.hidden = true; }
    if (returnFocus) $(".emh-top", li).focus();
  }
  items.forEach(li => {
    li.addEventListener("mouseenter", () => { if (isSmall() || coarse()) return; clearTimeout(tClose); clearTimeout(tOpen); if (openLi !== li) tOpen = setTimeout(() => openMega(li), openLi ? 70 : 150); });
    li.addEventListener("mouseleave", () => { clearTimeout(tOpen); if (!isSmall()) tClose = setTimeout(() => closeMega(), 260); });
    $(".emh-toggle", li)?.addEventListener("click", () => openLi === li ? closeMega() : openMega(li, { focus: true }));
    $(".emh-top", li).addEventListener("click", e => {
      if (isSmall()) { e.preventDefault(); window.EMH.openDrawer(li.dataset.emhItem); return; }
      if (coarse() && openLi !== li) { e.preventDefault(); openMega(li); }
    });
    $("[data-emh-mega]", li).addEventListener("keydown", e => { if (e.key === "Escape") { e.stopPropagation(); closeMega(true); } });
  });
  dim?.addEventListener("click", () => closeMega());
  dim?.addEventListener("mouseenter", () => { tClose = setTimeout(() => closeMega(), 160); });
  $(".emh-menubar", root)?.addEventListener("keydown", e => {
    const tops = $$(".emh-item:not([hidden]) .emh-top", root);
    const cur = e.target.closest(".emh-item"); if (!cur || e.target.closest("[data-emh-mega]")) return;
    const i = tops.indexOf($(".emh-top", cur));
    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      e.preventDefault();
      const n = tops[(i + (e.key === "ArrowRight" ? 1 : -1) + tops.length) % tops.length];
      n.focus(); const li = n.closest(".emh-item"); if (openLi && $("[data-emh-mega]", li)) openMega(li); else if (openLi) closeMega();
    } else if (e.key === "ArrowDown" && $("[data-emh-mega]", cur)) { e.preventDefault(); openMega(cur, { focus: true }); }
  });
  root.addEventListener("focusout", e => { if (openLi && e.relatedTarget && !openLi.contains(e.relatedTarget)) closeMega(); });

  /* Tabs (thickness) */
  function selectTab(mega, i, focus) {
    $$("[data-emh-tab]", mega).forEach(b => { const on = +b.dataset.emhTab === i; b.setAttribute("aria-selected", on); b.tabIndex = on ? 0 : -1; });
    $$("[role=tabpanel]", mega).forEach((p, j) => { p.hidden = j !== i; });
    if (focus) $(`[data-emh-tab="${i}"]`, mega)?.focus();
  }
  $$(".emh-mega-tabs", root).forEach(mega => {
    const n = $$("[data-emh-tab]", mega).length;
    mega.addEventListener("click", e => { const b = e.target.closest("[data-emh-tab]"); if (b) selectTab(mega, +b.dataset.emhTab); });
    mega.addEventListener("mouseover", e => { const b = e.target.closest("[data-emh-tab]"); if (b && b.getAttribute("aria-selected") !== "true") selectTab(mega, +b.dataset.emhTab); });
    mega.addEventListener("keydown", e => {
      const b = e.target.closest("[data-emh-tab]"); if (!b) return;
      const c = +b.dataset.emhTab, k = e.key === "ArrowDown" ? (c + 1) % n : e.key === "ArrowUp" ? (c - 1 + n) % n : null;
      if (k !== null) { e.preventDefault(); e.stopPropagation(); selectTab(mega, k, true); }
    });
  });

  /* ---------- Layers: drawer, side panels, palette ---------- */
  const scrim = $("[data-emh-scrim]");
  const layers = [];
  function openLayer(el, { focus, onClose } = {}) {
    if (!el || layers.some(l => l.el === el)) return;
    closeMega(); closePops();
    layers.push({ el, onClose, prev: document.activeElement });
    el.classList.add("is-open"); el.setAttribute("aria-hidden", "false");
    if (!el.classList.contains("emh-palette") && scrim) scrim.hidden = false;
    document.body.classList.add("emh-lock");
    requestAnimationFrame(() => (focus ? $(focus, el) : el.querySelector("button, a, input"))?.focus());
  }
  function closeLayer(el) {
    const i = el ? layers.findIndex(l => l.el === el) : layers.length - 1;
    if (i < 0) return;
    const [l] = layers.splice(i, 1);
    l.el.classList.remove("is-open"); l.el.setAttribute("aria-hidden", "true");
    l.onClose?.();
    if (!layers.some(x => !x.el.classList.contains("emh-palette")) && scrim) scrim.hidden = true;
    if (!layers.length) document.body.classList.remove("emh-lock");
    l.prev?.focus?.();
  }
  scrim?.addEventListener("click", () => { while (layers.length) closeLayer(); });
  document.addEventListener("click", e => { const c = e.target.closest("[data-emh-close]"); if (c) closeLayer(c.closest(".is-open")); });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") { if (layers.length) { e.preventDefault(); closeLayer(); } else if (openLi) closeMega(true); else closePops(); return; }
    if (e.key === "Tab" && layers.length) {
      const el = layers[layers.length - 1].el;
      const f = $$("a[href], button, input, select, [tabindex]:not([tabindex='-1'])", el).filter(x => !x.disabled && x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Drill-down drawer ---------- */
  const drawer = $("#emh-drawer"), track = $("[data-emh-track]");
  function resetDrawer() {
    $$(".emh-dpanel", track).forEach(p => { p.classList.toggle("is-right", p.dataset.emhLevel !== "root"); p.classList.remove("is-left"); });
  }
  function drill(id) {
    const lvl = $(`[data-emh-level="${CSS.escape(id)}"]`, track), rootP = $("[data-emh-level=root]", track);
    if (!lvl) return;
    lvl.classList.remove("is-right"); rootP.classList.add("is-left"); lvl.scrollTop = 0;
    setTimeout(() => $("[data-emh-back]", lvl)?.focus(), 30);
    document.dispatchEvent(new CustomEvent("emh:mega", { detail: lvl }));
    paintPrices(lvl);
  }
  function openDrawer(id) {
    if (!drawer) return;
    resetDrawer();
    document.dispatchEvent(new CustomEvent("emh:drawer"));
    $$("[data-emh-drawer-open]").forEach(b => b.setAttribute("aria-expanded", "true"));
    openLayer(drawer, { onClose: () => $$("[data-emh-drawer-open]").forEach(b => b.setAttribute("aria-expanded", "false")) });
    if (id) setTimeout(() => drill(id), 40);
  }
  track?.addEventListener("click", e => {
    const d = e.target.closest("[data-emh-drill]"); if (d) return drill(d.dataset.emhDrill);
    const b = e.target.closest("[data-emh-back]");
    if (b) { const lvl = b.closest(".emh-dpanel"); lvl.classList.add("is-right"); $("[data-emh-level=root]", track).classList.remove("is-left"); setTimeout(() => $(`[data-emh-drill="${lvl.dataset.emhLevel}"]`, track)?.focus(), 300); }
  });
  document.addEventListener("click", e => { if (e.target.closest("[data-emh-drawer-open]")) { e.preventDefault(); openDrawer(); } });

  /* ---------- Popovers (delivery, account) ---------- */
  const pops = $$("[data-emh-pop]", root);
  function setPop(btn, open) {
    const pop = document.getElementById(btn.dataset.emhPop); if (!pop) return;
    pop.hidden = !open; btn.setAttribute("aria-expanded", open);
    if (open) { closeMega(); pop.querySelector("input")?.focus({ preventScroll: true }); }
  }
  function closePops(except) { pops.forEach(b => { if (b !== except) setPop(b, false); }); }
  pops.forEach(btn => {
    const pop = document.getElementById(btn.dataset.emhPop); let t;
    btn.addEventListener("click", e => { e.stopPropagation(); const open = pop.hidden; closePops(btn); setPop(btn, open); });
    if (btn.dataset.emhPop === "emh-pop-account") {
      const wrap = btn.parentElement;
      wrap.addEventListener("mouseenter", () => { if (coarse() || isSmall()) return; clearTimeout(t); t = setTimeout(() => { closePops(btn); setPop(btn, true); }, 140); });
      wrap.addEventListener("mouseleave", () => { clearTimeout(t); t = setTimeout(() => setPop(btn, false), 260); });
    }
    pop.addEventListener("keydown", e => { if (e.key === "Escape") { e.stopPropagation(); setPop(btn, false); btn.focus(); } });
  });
  document.addEventListener("click", e => { if (!e.target.closest(".emh-pop")) closePops(); });

  /* ---------- Postcode check (free UK delivery; outside UK = quote) ---------- */
  const PC_FULL = /^([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})$/, PC_OUT = /^[A-Z]{1,2}\d[A-Z\d]?$/;
  function checkPostcode(raw) {
    const v = raw.toUpperCase().replace(/\s+/g, " ").trim(), f = v.replace(/\s/g, "").match(PC_FULL);
    const pretty = f ? `${f[1]} ${f[2]}` : PC_OUT.test(v) ? v : null;
    if (!pretty) return { ok: false };
    return { ok: true, pretty, outside: /^(IM|GY|JE)/.test(pretty) };
  }
  function showPostcode(r) {
    const out = $("[data-emh-pc-out]", root); if (!out) return;
    if (!r.ok) { out.innerHTML = `<span class="emh-err">That doesn't look like a UK postcode.</span> Try the format SW1A 1AA.`; return; }
    $$("[data-emh-pc-label]").forEach(el => el.textContent = r.pretty);
    out.innerHTML = r.outside
      ? `<span class="emh-ok">We can ship to ${esc(r.pretty)}.</span><br>The Isle of Man and Channel Islands are outside the UK, so email <b>${esc(D.email)}</b> for a shipping quote before you order.`
      : `<span class="emh-ok">Free delivery to ${esc(r.pretty)}.</span><br>${esc(D.dispatch || "Dispatched within 24 hours")}.`;
  }
  $("[data-emh-postcode]", root)?.addEventListener("submit", e => {
    e.preventDefault();
    const r = checkPostcode($("input", e.currentTarget).value); showPostcode(r);
    if (r.ok) store.set("pc", r.pretty);
  });
  const savedPc = store.get("pc", null);
  if (savedPc) { const inp = $("[data-emh-postcode] input", root); if (inp) inp.value = savedPc; showPostcode(checkPostcode(savedPc)); }

  /* ---------- Opening hours, rotator, cut-off (UK time) ---------- */
  const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], DAY = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const fmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
  const ukNow = () => { const p = Object.fromEntries(fmt.formatToParts(new Date()).map(x => [x.type, x.value])); return { d: DOW.indexOf(p.weekday), m: (+p.hour % 24) * 60 + +p.minute }; };
  const toMin = s => { if (!s || !String(s).trim()) return null; const [h, m] = String(s).split(":").map(Number); return isNaN(h) ? null : h * 60 + (m || 0); };
  const days = (D.openDays || "1,2,3,4,5").split(",").map(Number);
  const nextDay = d => { let n = (d + 1) % 7, k = 0; while (!days.includes(n) && k++ < 7) n = (n + 1) % 7; return n; };
  const hhmm = m => { const h = Math.floor(m / 60), mm = m % 60; return `${h % 12 || 12}${mm ? ":" + String(mm).padStart(2, "0") : ""}${h < 12 ? "am" : "pm"}`; };
  function tick() {
    const t = ukNow(), o = toMin(D.open), c = toMin(D.close), cut = toMin(D.cutoff);
    const open = days.includes(t.d) && o !== null && t.m >= o && t.m < c;
    $$("[data-emh-dot]").forEach(el => el.classList.toggle("is-closed", !open));
    const day = days.includes(t.d) && t.m < o ? t.d : nextDay(t.d);
    $$("[data-emh-open]").forEach(el => el.textContent = open ? `Experts online until ${hhmm(c)}` : `Lines open ${day === t.d ? "today" : DAY[day]} ${hhmm(o)}`);
    const note = $("[data-emh-railnote]", root);
    if (note && cut !== null) {
      if (days.includes(t.d) && t.m < cut) { const left = cut - t.m; note.innerHTML = `<b>Free UK delivery</b> · Order in <b>${Math.floor(left / 60)}h ${String(left % 60).padStart(2, "0")}m</b> for dispatch today`; }
      else note.innerHTML = `<b>Free UK delivery</b> · Order now for dispatch ${DAY[nextDay(t.d)]}`;
    }
  }
  tick(); setInterval(tick, 30000);
  const rot = $("[data-emh-rotator]", root);
  if (rot) {
    const msgs = (rot.dataset.messages || "").split("||").filter(Boolean); let i = 0;
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (msgs.length > 1) setInterval(() => {
      if (document.hidden) return; i = (i + 1) % msgs.length;
      if (reduce) { rot.textContent = msgs[i]; return; }
      rot.classList.add("is-out");
      setTimeout(() => { rot.classList.remove("is-out"); rot.classList.add("is-in"); rot.textContent = msgs[i]; requestAnimationFrame(() => requestAnimationFrame(() => rot.classList.remove("is-in"))); }, 450);
    }, 4500);
  }

  /* ---------- Compact header on scroll ---------- */
  const ann = $("[data-emh-announce]", root);
  // Themes read --header-height for sticky offsets; keep it equal to this header (after the theme's own resize handler)
  const setAnn = () => {
    if (ann) root.style.setProperty("--emh-announce-h", ann.offsetHeight + "px");
    if (root.dataset.setHeaderHeight !== "false") document.documentElement.style.setProperty("--header-height", root.offsetHeight + "px");
  };
  setAnn(); addEventListener("load", () => setTimeout(setAnn, 50)); addEventListener("resize", () => setTimeout(setAnn, 120));
  let lastY = scrollY, ticking = false;
  addEventListener("scroll", () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const y = scrollY;
      if (y < 160) root.classList.remove("emh-compact");
      else if (y > lastY + 6 && !openLi) root.classList.add("emh-compact");
      else if (y < lastY - 6) root.classList.remove("emh-compact");
      if (Math.abs(y - lastY) > 6) lastY = y;
      ticking = false;
    });
  }, { passive: true });

  paintPrices();
  window.EMH = { root, $, $$, esc, ic, store, money, shown, vatLabel, paintPrices, toast, openLayer, closeLayer, openDrawer, openMega: li => { const el = typeof li === "string" ? $(`[data-emh-item="${li}"]`, root) || $(`[data-emh-type="${li}"]`, root) : li; if (el) openMega(el); }, closeMega, isSmall, selectTab };
  document.dispatchEvent(new CustomEvent("emh:ready"));
})();
